import {
  Form,
  Card,
  Divider,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  DatePicker,
  Button,
  Modal,
  notification,
  message,
  Spin,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import moment from "moment";
import "../../sellThirt.css";

import { format } from "../../../App";
import MenuBar from "../../menu/MenuBar";
import { delUser, setUser } from "../../../app/features/user/userSlice";
import { postData, getOptionDriver, pad } from "../../../data/allfunction";
import { Spinshow } from "../../SellPac";
import {
  getDataPost_2,
  getPDF_2,
  getTextDate,
} from "../../../data/allfunction_2";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
const dateFormat = "DD-MM-YYYY";
const ip = process.env.REACT_APP_IP;
const { Option } = Select;
function SellOld() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const userData = useSelector((state) => {
    return state.user;
  });
  const { token, retoken, user, user_id, agent_Code, agent_id } = userData;

  const [modalsave, setmodalsave] = useState(false);
  const [stateButtonSave, setstateButtonSave] = useState(true);
  // --------------------

  const [premuim, setpremuim] = useState(0);
  const [vat, setvat] = useState(0);

  const [register, setregister] = useState(0);
  const [total_premuim, settotal_premuim] = useState(0);
  const [current, setcurrent] = useState("");

  const [emp_paid, setemp_paid] = useState(0);

  const [loadingPDF, setloadingPDF] = useState(false);

  const [type_cover, set_type_cover] = useState([]);
  const [type_cover_select, set_type_cover_select] = useState({});

  const [packages, set_packages] = useState([]);
  const [packages_select, set_packages_select] = useState({});

  const [options, set_options] = useState([]);
  const [options_select, set_options_select] = useState({});

  const [list_days, set_list_days] = useState([]);
  const [list_days_select, set_list_days_select] = useState({});

  // "op_day_id": 6,
  // "agent_id":15,

  const [op_day_id, set_op_day_id] = useState(null);
  // agent_id ມີແລ້ວບໍ່ຕ້ອງສ້າງ
  // const [agent_id,set_agent_id] = useState(null)

  // "con_name": "con_name26-2",
  // "con_start": "2024-01-01",
  // "con_end": "2024-01-30",
  // "con_create": "con_create 26-2",
  // "con_go": "con_go 26",
  // "con_detail": "con_detail 26-2",
  // "con_note": "con_note 26-2",

  const [con_name, set_con_name] = useState("");
  const [con_start, set_con_start] = useState("");
  const [con_end, set_con_end] = useState("");
  const [con_create, set_con_create] = useState(Date.now());
  const [con_go, set_con_go] = useState("");
  const [con_detail, set_con_detail] = useState("");
  const [con_note, set_con_note] = useState("");
  const [op_type_cov_name, set_op_type_cov_name] = useState(null);

  // "people_name": "people_name 26-2",
  // "people_name_e": "people_name_e 26-2",
  // "people_brith": "2020-01-26",
  // "people_place_brith": "people_place_brith 26-2",
  // "people_id_card": "people_id_card 26-2",
  // "people_stay": "people_stay 26-2",
  // "people_stay_e": "people_stay_e 26-2",
  // "people_note": "people_note 26-2",

  const [person, set_person] = useState({});
  const [people_id_, set_people_id_] = useState(null);

  const [people_id, set_people_id] = useState(null);
  const [people_name, set_people_name] = useState("");
  const [people_name_e, set_people_name_e] = useState("");
  const [people_brith, set_people_brith] = useState(Date.now());
  const [people_place_brith, set_people_place_brith] = useState("");
  const [people_id_card, set_people_id_card] = useState("");
  const [people_stay, set_people_stay] = useState("");
  const [people_stay_e, set_people_stay_e] = useState("");
  const [people_note, set_people_note] = useState("");

  // "people_con_create": "people_con_create",
  const [people_con_create, set_people_con_create] = useState(Date.now());

  // "people_con_ben": {
  //   "name_ben": "ນາງ ແສງສຸພາ ທອງປະກາຍ",
  //   "name_ben_e": "Mrs. sangsupa THONGPAKAY",
  //   "addr_ben":"ບ.ຕານມີໄຊ, ມ.ໄຊທານີ ນະຄອນຫຼວງວຽງຈັນ",
  //   "addr_ben_e":"Tanmixay Village, Xaithany District, Vientiane Capital,  Lao PDR",
  //   "relation_ben":"ແມ່",
  //   "relation_ben_e":"Mather",
  //   "id_ben":"PA 0363203",
  //   "date_ben_birth":"26/07/1982"
  //  },

  const [name_ben, set_name_ben] = useState("");
  const [name_ben_e, set_name_ben_e] = useState("");
  const [addr_ben, set_addr_ben] = useState("");
  const [addr_ben_e, set_addr_ben_e] = useState("");
  const [relation_ben, set_relation_ben] = useState("");
  const [relation_ben_e, set_relation_ben_e] = useState("");
  const [id_ben, set_id_ben] = useState("");
  const [date_ben_birth, set_date_ben_birth] = useState("");

  // "people_con_note": "people_con_note 26"

  const [people_con_note, set_people_con_note] = useState("");
  const [loadingPea, set_loadingPea] = useState(false);
  // ---------------------
  function onChange_timestart(value, dateString) {
    // setstartCover(moment(value).format(dateFormat));
    // setsent_startCover(value);
    console.log(value);
    set_con_start(value);
  }

  function onChange_timeend(value, dateString) {
    // setendCover(moment(value).format(dateFormat));
    // setsent_endCover(value);
    set_con_end(value);
  }

  //ຟັ່ງຊັ່ນດາວໂຫລດ ສັນຍາເປັນພີດີເອຟ
  async function get_pdf_policy(no) {
    let l = ip + "non_motor/get_hpa_for_pdf_multi";
    let dataSetForGet = { con_id: no };
    let pro = await getPDF_2(l, dataSetForGet, token, retoken);

    // Create a temporary URL representing the Blob
    const url = window.URL.createObjectURL(pro);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = pad(no);

    // Append the link to the body
    document.body.appendChild(a);

    // Trigger a click event on the link to initiate download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  //ສ້າງສັນຍາ ແລະ ດາວໂຫລດ
  async function createPolicy() {
    setstateButtonSave(false);

    let rows = {
      op_day_id,
      agent_id,

      con_name: people_name + ` (${moment(con_create).format("YYYY-MM-DD")})`,
      con_start: moment(con_start).format("YYYY-MM-DD"),
      con_end: moment(con_end).format("YYYY-MM-DD"),
      con_create: moment(con_create).format("YYYY-MM-DD"),
      con_go,
      con_detail,
      con_note,
      op_type_cov_name,

      people_id,
      // people_name,
      // people_name_e,
      // people_brith: moment(people_brith).format("YYYY-MM-DD"),
      // people_place_brith,
      // people_id_card,
      // people_stay,
      // people_stay_e,
      // people_note,

      people_con_create: moment(people_con_create).format("YYYY-MM-DD"),

      people_con_ben: {
        name_ben,
        name_ben_e,
        addr_ben,
        addr_ben_e,
        relation_ben,
        relation_ben_e,
        id_ben,
        date_ben_birth,
      },
      people_con_note,
    };
    console.log(rows);
    // return;

    let l = ip + "non_motor/add_non_motor_renew_by_people_id";
    let addpolicy = await getDataPost_2(l, rows, token, retoken);
    console.log(addpolicy);
    // let a = {
    //   contract_id: 58,
    //   people_con_id: 45,
    //   cov_in_con_id: 131,
    //   people_id: 45,
    // };
    if (addpolicy.contract_id > 0) {
      notification["success"]({
        message: "ແຈ້ງເຕືອນ",
        description:
          "ສ້າງສັນຍາປະກັນໄພອອນລາຍ ເລກທີ: " +
          pad(addpolicy.contract_id) +
          " ສຳເຫຼັ້ດ ກະລຸນາກວດສອບໂຟເດີ້ ດາວໂລດ",
      });
      //ສະເພາະສັນຍາທີ່ສ້າງພີດີເອຟ ແລ້ວ
      get_pdf_policy(addpolicy.contract_id);
      setTimeout(() => {
        window.location.reload();
        setmodalsave(false);
        setloadingPDF(false);

        notification.destroy();
      }, 2000);
    } else {
      setloadingPDF(false);
      setmodalsave(false);
    }
    setTimeout(() => {
      setstateButtonSave(true);
    }, 3000);
  }

  const submitForm = (e) => {
    if (op_day_id === null || people_id == null) {
      notification["error"]({
        message: "ແຈ້ງເຕືອນ",
        description: (
          <>
            ກະລຸນາກວດສອບ ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ ຫຼື
            <p>1. ປະເພດການຄຸ້ມກັນ</p>
            <p>2. ແພັກແກັດ</p>
            <p>3. ທາງເລືອກແພັກແກັດ</p>
            <p>4. ຈຳນວນວັນ</p>
            ໃຫ້ຄົບຖ້ວນ
          </>
        ),
      });
      return;
    }
    setmodalsave(true);
    // form.resetFields()
  };

  //ຟັ່ງຊັ່ນດຶງຂໍ້ມູນລູກຄ້າເກົ່າ
  async function getPerson() {
    set_loadingPea(true);
    console.log(people_id_);
    try {
      let l = ip + "non_motor/people";
      let dataSetForGet = { people_id: people_id_ };
      let pea = await getDataPost_2(l, dataSetForGet, token, retoken);
      console.log(pea);
      console.log(pea.data.length > 0);
      if (pea.data.length > 0) {
        console.log(pea.data[0]);
        set_person(pea.data[0]);

        set_people_id(pea.data[0]?.people_id);
        set_people_name(pea.data[0]?.people_name);
        set_people_name_e(pea.data[0]?.people_name_e);

        console.log(moment(pea.data[0]?.people_brith).format("DD-MM-YYYY"));
        if (
          pea.data[0]?.people_brith != undefined ||
          pea.data[0]?.people_brith != null ||
          pea.data[0]?.people_brith != ""
        ) {
          set_people_brith(pea.data[0]?.people_brith);
        }
        set_people_place_brith(pea.data[0]?.people_place_brith);
        set_people_id_card(pea.data[0]?.people_id_card);
        set_people_stay(pea.data[0]?.people_stay);
        set_people_stay_e(pea.data[0]?.people_stay_e);
        set_people_note(pea.data[0]?.people_note);

        let person = JSON.parse(pea.data[0].people_con_ben);
        set_name_ben(person.name_ben == undefined ? "" : person.name_ben);
        set_name_ben_e(person.name_ben_e == undefined ? "" : person.name_ben_e);
        set_addr_ben(person.addr_ben == undefined ? "" : person.addr_ben);
        set_addr_ben_e(person.addr_ben_e == undefined ? "" : person.addr_ben_e);
        set_relation_ben(
          person.relation_ben == undefined ? "" : person.relation_ben
        );
        set_relation_ben_e(
          person.relation_ben_e == undefined ? "" : person.relation_ben_e
        );
        set_id_ben(person.id_ben == undefined ? "" : person.id_ben);
        set_date_ben_birth(
          person.date_ben_birth == undefined ? "" : person.date_ben_birth
        );
      } else {
        throw new Error("ບໍ່ມີຂໍ້ມູນຜູ້ຄຸ້ມກັນໃນລະຫັດນີ້");
      }
    } catch (error) {
      // console.log("Error message: ", error.message);
      console.log("Full error object: ", error);
      // console.log(
      //   "Stringified error object: ",
      //   JSON.stringify({
      //     message: error.message,
      //     name: error.name,
      //     stack: error.stack,
      //   })
      // );

      notification["error"]({
        message: "ແຈ້ງເຕືອນ",
        description: error?.message,
      });
      set_person({});
      set_name_ben("");
      set_name_ben_e("");
      set_addr_ben("");
      set_addr_ben_e("");
      set_relation_ben("");
      set_relation_ben_e("");
      set_id_ben("");
      set_date_ben_birth("");
    } finally {
      setTimeout(() => {
        set_loadingPea(false);
      }, 500);
    }
  }

  //ດຶງປະເພດການຄຸ້ມກັນ
  useEffect(() => {
    getData();
    async function getData() {
      try {
        let l = ip + "non_motor/get_type_cover";
        let dataSetForGet = {};
        let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
        console.log(pro.data.length > 0);
        if (pro.data.length > 0) {
          set_type_cover(pro.data);
        } else {
        }
      } catch (error) {
        console.log("error 140");
        set_type_cover([]);
      }
    }
  }, [token, retoken]);

  //ດຶງແພັກແກັດການຄຸ້ມກັນ
  useEffect(() => {
    getData();
    async function getData() {
      try {
        if (
          typeof type_cover_select.type_cov_id !== "number" ||
          type_cover_select.type_cov_id < 0
        ) {
          throw new Error();
        }
        let l = ip + "non_motor/get_hpa_packages";
        let dataSetForGet = { type_cov_id: type_cover_select?.type_cov_id };
        let pac = await getDataPost_2(l, dataSetForGet, token, retoken);
        console.log("140");
        console.log(pac.data);
        if (pac.data.length > 0) {
          set_packages(pac.data);
        } else {
          set_packages([]);
          set_packages_select({});
        }
      } catch (error) {
        console.log("error 168");
        set_packages([]);
        set_packages_select({});
      }
    }
  }, [token, retoken, type_cover_select]);

  //ດຶງທາງເລືອກການຄຸ້ມກັນດ້ວຍລະຫັດແພັກແກັດ

  useEffect(() => {
    getData();

    async function getData() {
      try {
        if (
          typeof packages_select.pac_id !== "number" ||
          packages_select.pac_id < 0
        ) {
          throw new Error();
        }
        let l = ip + "non_motor/get_hpa_option";
        let dataSetForGet = { pac_id: packages_select?.pac_id };
        let op = await getDataPost_2(l, dataSetForGet, token, retoken);
        console.log("178");
        console.log(op.data);
        if (op.data.length > 0) {
          set_options(op.data);
        } else {
          set_options([]);
          set_options_select({});
        }
      } catch (error) {
        console.log("error 201 - " + JSON.stringify(packages_select.pac_id));
        set_options([]);
        set_options_select({});
      }
    }
  }, [token, retoken, packages_select]);

  //ດຶງຈຳນວນວັນດ້ວຍລະຫັດທາງເລືອກ list_days_by_op_id
  useEffect(() => {
    console.log("options_select");
    console.log(options_select);
    getData();
    async function getData() {
      try {
        if (
          typeof options_select.op_id !== "number" ||
          options_select.op_id < 0
        ) {
          throw new Error("options_select Error");
        }
        let l = ip + "non_motor/get_hpa_list_days_by_op_id";
        let dataSetForGet = { op_id: options_select?.op_id };
        let op = await getDataPost_2(l, dataSetForGet, token, retoken);
        console.log("198");
        console.log(op.data);
        if (op.data.length > 0) {
          set_list_days(op.data);
        } else {
          set_list_days([]);
          set_list_days_select({});
        }
      } catch (error) {
        console.log("error 233");
        set_list_days([]);
        set_list_days_select({});
      }
    }
  }, [token, retoken, options_select]);

  //ແຊັດຄ່າເມື່ອ list_days_select ມີການປ່ຽນແປງ
  useEffect(() => {
    console.log(list_days_select);
    try {
      if (list_days_select.op_day_total_premium === undefined) {
        throw new Error();
      }
      setpremuim(list_days_select?.op_day_premium);
      setvat(list_days_select?.op_day_vat);
      setregister(list_days_select?.op_day_re);
      settotal_premuim(list_days_select?.op_day_total_premium);
      setcurrent(list_days_select?.op_day_cur);

      set_op_day_id(list_days_select.op_day_id);
    } catch (error) {
      setpremuim(0);
      setvat(0);
      setregister(0);
      settotal_premuim(0);
      setcurrent("");
      set_op_day_id(null);
    }
  }, [token, retoken, list_days_select]);
  return (
    <>
      {loadingPDF ? (
        <Spinshow />
      ) : (
        <Form
          form={form}
          name="sellpac"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={submitForm}
          autoComplete="off"
        >
          <div className="container">
            {/* { JSON.stringify(userData)} */}
            <Card className="C">
              <Divider orientation="left" plain>
                1. ຂໍ້ມູນລະອຽດຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ / Details of the Insured
              </Divider>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ລະຫັດລູກຄ້າ
                      <InputNumber
                        style={{ width: "100%" }}
                        className="TI"
                        placeholder="ລະຫັດລູກຄ້າ"
                        onChange={(v) => {
                          set_people_id_(v);
                        }}
                        value={people_id_}
                      />
                    </div>
                    <div className="col">
                      <br />
                      <Button
                        loading={loadingPea}
                        onClick={() => {
                          getPerson();
                        }}
                      >
                        ຄົ້ນຫາຂໍ້ມູນລູກຄ້າ
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {person.people_name != undefined && (
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 2, paddingRight: 10 }}>
                    <div className="row">
                      <div className="col">
                        {" "}
                        ຊື່: {person.people_name}/{person.people_name_e}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        {" "}
                        ວັນເດືອນປີເກີດ:
                        {moment(person.people_brith).format("DD-MM-YYYY")}
                      </div>
                      <div className="col">
                        {" "}
                        ບ້ານເກີດ:{person.people_place_brith}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        ບ້ານຢູ່ປະຈຸບັນ:{person.people_stay}/
                        {person.people_stay_e}
                      </div>
                      <div className="col"></div>
                    </div>
                    <div className="row">
                      <div className="col">
                        {" "}
                        ເລກທີບັດປະຊາຊົນ:{person.people_id_card}
                      </div>
                      <div className="col">ໝາຍເຫດ:{person.people_note}</div>
                    </div>
                  </div>
                </div>
              )}
            </Card>

            <Card className="C">
              <Divider orientation="left" plain>
                2. ຜົນປະໂຫຍດການປະກັນໄພ/ Insured Interests
              </Divider>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        label="ວັນທີເລີ່ມຄຸ້ມກັນ::"
                        name="con_start"
                        rules={[
                          {
                            required: true,
                            message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                          className="DP"
                          //showTime
                          onChange={onChange_timestart}
                          format={dateFormat}
                          disabledDate={(current) =>
                            current.isBefore(moment().subtract(1, "day"))
                          }
                        />
                      </Form.Item>
                    </div>
                    <div className="col">
                      <Form.Item
                        label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                        name="end"
                        rules={[
                          {
                            required: true,
                            message: "ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ",
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="ວັນທີສຶ້ນສຸດຄຸ້ມກັນ"
                          className="DP"
                          // showTime
                          onChange={onChange_timeend}
                          format={dateFormat}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ຂອບເຂດພູມສັນຖານ
                      <Input
                        className="TI"
                        placeholder="ຂອບເຂດພູມສັນຖານ:"
                        onChange={(v) => {
                          set_con_go(v.target.value);
                          // console.log(v.target.value);
                        }}
                        value={con_go}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ປະເພດການຄຸ້ມກັນ
                      <Select
                        placeholder="ປະເພດການຄຸ້ມກັນ"
                        optionFilterProp="children"
                        onChange={(v) => {
                          try {
                            let d = JSON.parse(v);
                            //  console.log(d);
                            set_packages_select({});
                            set_type_cover_select(d);

                            set_op_type_cov_name(d?.type_cov_name);
                          } catch (error) {
                            console.log(error);
                            set_op_type_cov_name(null);
                          }
                        }}
                        className="TI"
                        value={type_cover_select?.type_cov_name}
                        style={{ width: "100%" }}
                      >
                        {type_cover.map((e) => {
                          return (
                            <Option
                              key={e.type_cov_id}
                              value={JSON.stringify(e)}
                            >
                              {e.type_cov_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ເລືອກແພັກແກັດ
                      {/* {JSON.stringify(packages_select)} */}
                      <Select
                        placeholder="ເລືອກແພັກແກັດ"
                        optionFilterProp="children"
                        onChange={(v) => {
                          set_options_select({});
                          let p = JSON.parse(v);
                          set_packages_select(p);
                        }}
                        className="TI"
                        style={{ width: "100%" }}
                        value={packages_select?.pac_name}
                      >
                        {packages.map((e) => {
                          return (
                            <Option key={e.pac_id} value={JSON.stringify(e)}>
                              {e.pac_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ທາງເລືອກແພັກແກັດ
                      {/*   {JSON.stringify(options_select)} */}
                      <Select
                        placeholder="ທາງເລືອກແພັກແກັດ"
                        optionFilterProp="children"
                        onChange={(v) => {
                          let o = JSON.parse(v);
                          set_list_days_select({});
                          set_options_select(o);
                        }}
                        className="TI"
                        style={{ width: "100%" }}
                        value={options_select?.op_name}
                      >
                        {options.map((e) => {
                          return (
                            <Option key={e.op_id} value={JSON.stringify(e)}>
                              {e.op_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ຈຳນວນວັນທີ່ຕ້ອງການ
                      {/* {JSON.stringify(list_days_select)} */}
                      <Select
                        placeholder="ຈຳນວນວັນທີ່ຕ້ອງການ"
                        optionFilterProp="children"
                        onChange={(v) => {
                          set_list_days_select(JSON.parse(v));
                        }}
                        className="TI"
                        style={{ width: "100%" }}
                        value={list_days_select?.list_day_name}
                      >
                        {list_days.map((e) => {
                          return (
                            <Option
                              key={e.list_day_id}
                              value={JSON.stringify(e)}
                            >
                              {e.list_day_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ລາຍລະອຽດເພີ່ມຕື່ມ
                      <Input
                        className="TI"
                        placeholder="ລາຍລະອຽດເພີ່ມຕື່ມ"
                        onChange={(v) => {
                          set_con_detail(v.target.value);
                          // console.log(v.target.value);
                        }}
                        value={con_detail}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="C">
              <Divider orientation="left" plain>
                3. ຂໍ້ມູນຜູ້ໄດ້ຮັບຜົນປະໂຫຍດ/ Insurance beneficiaries
              </Divider>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ຊື່ ແລະ ນາມສະກຸນ
                      <Input
                        className="TI"
                        placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                        onChange={(v) => {
                          set_name_ben(v.target.value);
                        }}
                        value={name_ben}
                      />
                    </div>
                    <div className="col">
                      * ຊື່ ແລະ ນາມສະກຸນ ພາສາຕ່າງປະເທດ
                      <Input
                        className="TI"
                        placeholder="ຊື່ ແລະ ນາມສະກຸນ ພາສາຕ່າງປະເທດ"
                        onChange={(v) => {
                          set_name_ben_e(v.target.value);
                        }}
                        value={name_ben_e}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ທີ່ຢູ່
                      <Input
                        className="TI"
                        placeholder="ທີ່ຢູ່"
                        onChange={(v) => {
                          set_addr_ben(v.target.value);
                        }}
                        value={addr_ben}
                      />
                    </div>
                    <div className="col">
                      * ທີ່ຢູ່ ພາສາຕ່າງປະເທດ
                      <Input
                        className="TI"
                        placeholder="ທີ່ຢູ່ ພາສາຕ່າງປະເທດ"
                        onChange={(v) => {
                          set_addr_ben_e(v.target.value);
                        }}
                        value={addr_ben_e}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ສາຍພົວພັນ
                      <Input
                        className="TI"
                        placeholder="ສາຍພົວພັນ"
                        onChange={(v) => {
                          set_relation_ben(v.target.value);
                        }}
                        value={relation_ben}
                      />
                    </div>
                    <div className="col">
                      * ສາຍພົວພັນ ພາສາຕ່າງປະເທດ
                      <Input
                        className="TI"
                        placeholder="ສາຍພົວພັນ ພາສາຕ່າງປະເທດ"
                        onChange={(v) => {
                          set_relation_ben_e(v.target.value);
                        }}
                        value={relation_ben_e}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <div className="row">
                    <div className="col">
                      * ເລກທີບັດປະຊາຊົນຫຼື ໜັງສືຜ່ານແດນ
                      <Input
                        className="TI"
                        placeholder="ເລກທີບັດປະຊາຊົນຫຼື ໜັງສືຜ່ານແດນ"
                        onChange={(v) => {
                          set_id_ben(v.target.value);
                        }}
                        value={id_ben}
                      />
                    </div>
                    <div className="col">
                      * ວັນເດືອນປີເກີດ ຕົວຢ່າງການບັນທຶກ 01/01/2000
                      <Input
                        className="TI"
                        placeholder="ວັນເດືອນປີເກີດ ຕົວຢ່າງການບັນທຶກ 01/01/2000"
                        onChange={(v) => {
                          set_date_ben_birth(v.target.value);
                        }}
                        value={date_ben_birth}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                ຄິດໄລຄ່າທຳນຽມ
              </Divider>
              <div className="B">
                <div className="B1"> ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ </div>
                <div className="B2">
                  {format(premuim)} {current}
                </div>
              </div>
              <div className="B">
                <div className="B1"> ອາກອນມູນຄ່າເພີ່ມ </div>
                <div className="B2">
                  {format(vat)} {current}
                </div>
              </div>
              <div className="B">
                <div className="B1"> ຄ່າຂື້ນທະບຽນ </div>
                <div className="B2">
                  {format(register)} {current}
                </div>
              </div>
              <div className="B">
                <div className="B1"> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
                <div className="B2">
                  {format(total_premuim)} {current}
                </div>
              </div>
            </Card>

            {/* <Card className="C">
                  <Divider orientation="left" plain>
                    ການຊຳລະເງິນ
                  </Divider>
                  <div className="BDP">
                    <div className="B1DP">ສະຖານະການຊຳລະ</div>
                    <div className="B2DP">
                      <Radio.Group
                        onChange={(e) => {
                          setemp_paid(e.target.value);
                        }}
                        value={emp_paid}
                      >
                        <Radio value={0}>ລໍຖ້າການຊຳລະ</Radio>
                        <Radio value={1}>ຊຳລະສົມບູນ</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                </Card> */}
            <Card className="C">
              <div className="BDP">
                {" "}
                {InsuranceConditions(packages_select?.pac_term)}
              </div>
            </Card>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                ບັນທຶກຂໍ້ມູນ
              </Button>
            </Form.Item>
          </div>
        </Form>
      )}
      <br />
      <Modal
        title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
        visible={modalsave}
        onOk={() => {
          if (stateButtonSave) {
            createPolicy();
          } else {
            alert("ກະລຸນາລໍຖ້າ ທ່ານໃດ້ກົດບັນທຶກຂໍ້ມູນແລ້ວ");
          }
        }}
        onCancel={() => setmodalsave(false)}
        okText={
          stateButtonSave ? (
            "ຕົກລົງ"
          ) : (
            <>
              <Spin
                indicator={<LoadingOutlined style={{ color: "#FFF" }} spin />}
              />
            </>
          )
        }
        cancelText="ຍົກເລີກ"
      >
        {/* <div className="B">
              <div className="B1"> ສະຖານະການຈ່າຍເງິນ </div>
              <div className="B2">
                {" "}
                {emp_paid === 1 ? "ຊຳລະສົມບູນ" : "ລໍຖ້າການຊຳລະ"}{" "}
              </div>
            </div> */}

        <div className="B">
          <div className="B1"> ຊື່ ແລະ ນາມສະກຸນ </div>
          <div className="B2">{people_name}</div>
        </div>
        <div className="B">
          <div className="B1"> ເລກທີບັດປະຊາຊົນຫຼື ໜັງສືຜ່ານແດນ </div>
          <div className="B2">{people_id_card}</div>
        </div>
        <div className="B">
          <div className="B1"> ຂອບເຂດພູມສັນຖານ </div>
          <div className="B2">{con_go}</div>
        </div>
        <div className="B">
          <div className="B1"> ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ </div>
          <div className="B2">
            {format(premuim)} {current}
          </div>
        </div>
        <div className="B">
          <div className="B1"> ອາກອນມູນຄ່າເພີ່ມ </div>
          <div className="B2">
            {format(vat)} {current}
          </div>
        </div>
        <div className="B">
          <div className="B1"> ຄ່າຂື້ນທະບຽນ </div>
          <div className="B2">
            {format(register)} {current}
          </div>
        </div>
        <div className="B">
          <div className="B1"> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
          <div className="B2">
            {format(total_premuim)} {current}
          </div>
        </div>

        <div className="B">
          <div className="B1"> ວັນທີເລີ່ມຄຸ້ມກັນ </div>
          <div className="B2">{moment(con_start).format("DD/MM/YYYY")}</div>
        </div>
        <div className="B">
          <div className="B1"> ວັນທີສຶ້ນສຸດຄຸ້ມກັນ </div>
          <div className="B2">{moment(con_end).format("DD/MM/YYYY")}</div>
        </div>
      </Modal>
    </>
  );
}

export default SellOld;

function InsuranceConditions(i) {
  try {
    return (
      <div>
        {i.split("\n").map((line, index) => (
          <p style={{ color: "red" }} key={index}>
            {line.trim()}
          </p>
        ))}
      </div>
    );
  } catch (error) {
    return "";
  }
}
